document.addEventListener('DOMContentLoaded', () => {
  const guideEl = document.getElementById('sizeGuide');
  if (!guideEl) return;

  const html = document.documentElement;
  const body = document.body;

  const openGuide = () => {
    guideEl.classList.add('active');

    // scroll lock (werkt op meeste themes/browsers)
    html.classList.add('overflow-hidden');
    body.classList.add('overflow-hidden');

    // extra safety: voorkom iOS "background scroll"
    body.style.touchAction = 'none';
  };

  const closeGuide = () => {
    guideEl.classList.remove('active');

    // altijd unlocken
    html.classList.remove('overflow-hidden');
    body.classList.remove('overflow-hidden');

    body.style.touchAction = '';
  };

  // 1) Open via trigger
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.size-guide-trigger');
    if (!trigger) return;

    e.preventDefault();
    openGuide();
  });

  // 2) Close via overlay / X / rode knop (of elk element met data-close)
  guideEl.addEventListener('click', (e) => {
    // overlay click
    if (e.target.classList.contains('size-guide__overlay')) {
      closeGuide();
      return;
    }

    // close buttons
    if (e.target.closest('.size-guide__close') || e.target.closest('[data-size-guide-close]')) {
      e.preventDefault();
      closeGuide();
    }
  });

  // 3) Escape sluit
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!guideEl.classList.contains('active')) return;
    closeGuide();
  });
});
